export const NUMBER_OF_COLUMNS = 96

export const AUDIO_FORMAT = 'wav'

export const UINT8ARRAY = new Uint8Array(NUMBER_OF_COLUMNS * 2)
